import { createContext } from "react";
const DocContext = createContext();

export default DocContext;